import {
  distinctUntilChanged,
  map,
  pluck,
} from "rxjs/operators";

const create$ = (state$) => {
  const myHover$ = state$.pipe(
    pluck("three", "hover"),
    distinctUntilChanged(),
    map((hover) => (hover ? [hover] : []))
  );

  return myHover$;
};

export default create$;